import {Service} from './request';

export default {
    getParentCompanyUser() {
        return Service.post("/home/parent/company/user");
    },
    getAllMerchantPayOrderAmount(start, end) {
        return Service.post("/home/merchant/pay/order", {start, end});
    },
    getAllFree(start, end) {
        return Service.post("/home/parent/company/free", {start, end});
    },
    getAllBonus(start, end) {
        return Service.post("/home/parent/company/bonus", {start, end});
    },
    getAllRemitAndExchange(start, end) {
        return Service.post("/home/parent/company/exchange", {start, end});
    },
    getAllInterest(start, end) {
        return Service.post("/home/parent/company/interest", {start, end});
    },
    getExchangeWaiting(start, end) {
        return Service.post("/home/parent/company/exchange/order", {start, end});
    },
    getWithdrawRecords(start, end) {
        return Service.post("/home/parent/company/access/withdraw", {start, end});
    },
    getAllFault(start, end) {
        return Service.post("/home/parent/company/order/fault", {start, end});
    },
    getAllFreezePay() {
        return Service.post("/home/parent/company/order/freeze");
    },
    getAllCreditLimit(start, end) {
        return Service.post("/home/parent/company/credit/limit", {start, end});
    },
    getAllPayOrderProcess(start, end) {
        return Service.post("/home/parent/company/order/process", {start, end});
    },
    getMerchantTodayPayDetail(start, end, span) {
        return Service.post("/home/parent/company/merchant/today/pay", {startDate: start, endDate: end, span});
    },
    getParentCompanyProfit(start, end, span) {
        return Service.post("/home/parent/company/profit/today/pay", {startDate: start, endDate: end, span});
    },
    getChildCompanyVipDetail(start, end) {
        return Service.post("/home/child/company/vip/order", {start, end});
    },
    getChildAllFree(start, end) {
        return Service.post("/home/child/company/vip/free", {start, end});
    },
    getChildAllBonus(start, end) {
        return Service.post("/home/child/company/vip/bonus", {start, end});
    },
    getChildAllRemitAndExchange(start, end) {
        return Service.post("/home/child/company/vip/remit/exchange", {start, end});
    },
    getChildAllInterest(start, end) {
        return Service.post("/home/child/company/vip/interest", {start, end});
    },
    getChildExchangeWaiting(start, end) {
        return Service.post("/home/child/company/vip/remit/record", {start, end});
    },
    getChildAllPayOrderProcess(start, end) {
        return Service.post("/home/child/company/order/process", {start, end});
    },
    getChildAllCreditLimit(start, end) {
        return Service.post("/home/child/company/credit/limit", {start, end});
    },
    getChildAllFault(start, end) {
        return Service.post("/home/child/company/order/fault", {start, end});
    },
    getChildAllAccessCompany(start, end) {
        return Service.post("/home/child/company/access/remit", {start, end});
    },
    getCompanyVipTodayPayDetail(start, end, span) {
        return Service.post("/home/child/company/vip/today/pay", {start, end, span});
    },
    getChildCompanyProfit(start, end, span) {
        return Service.post("/home/child/company/profit/today/pay", {start, end, span});
    },
    getMerchantAllPayOrder(start, end) {
        return Service.post("/home/merchant/order/detail", {start, end});
    },
    getMerchantAllFree(start, end) {
        return Service.post("/home/merchant/all/free", {start, end});
    },
    getMerchantAllRemitAndExchange(start, end) {
        return Service.post("/home/merchant/remit/exchange", {start, end});
    },
    getMerchantAllInterest(start, end) {
        return Service.post("/home/merchant/interest", {start, end});
    },
    getMerchantAllFault(start, end) {
        return Service.post("/home/merchant/order/fault", {start, end});
    },
    getMerchantAllPayOrderProcess(start, end) {
        return Service.post("/home/merchant/order/process", {start, end});
    },
    getMerchantVipTodayPayDetail(start, end, span) {
        return Service.post("/home/merchant/vip/today/pay", {start, end, span});
    },
    getMerchantCompanyProfit(start, end, span) {
        return Service.post("/home/merchant/profit/today/pay", {start, end, span});
    },
    getCompanyAgentVipDetail(start, end) {
        return Service.post("/home/company/agent/order/detail", {start, end});
    },
    getCompanyAgentAllFree(start, end) {
        return Service.post("/home/company/agent/vip/free", {start, end});
    },
    getCompanyAgentAllBonus(start, end) {
        return Service.post("/home/company/agent/vip/bonus", {start, end});
    },
    getCompanyAgentAllRemitAndExchange(start, end) {
        return Service.post("/home/company/agent/remit/exchange", {start, end});
    },
    getCompanyAgentAllPayOrderProcess(start, end) {
        return Service.post("/home/company/agent/order/process", {start, end});
    },
    getCompanyAgentTodayPayDetail(start, end, span) {
        return Service.post("/home/company/agent/today/pay", {start, end, span});
    },
    getCompanyAgentProfit(start, end, span) {
        return Service.post("/home/company/agent/profit/today/pay", {start, end, span});
    },
    getMerchantAgentAllPayOrder(start, end) {
        return Service.post("/home/merchant/agent/order/detail", {start, end});
    },
    getMerchantAgentAllFree(start, end) {
        return Service.post("/home/merchant/agent/all/free", {start, end});
    },
    getMerchantAgentAllBonus(start, end) {
        return Service.post("/home/merchant/agent/vip/bonus", {start, end});
    },
    getMerchantAgentAllRemitAndExchange(start, end) {
        return Service.post("/home/merchant/agent/remit/exchange", {start, end});
    },
    getMerchantAgentAllPayOrderProcess(start, end) {
        return Service.post("/home/merchant/agent/order/process", {start, end});
    },
    getMerchantAgentTodayPayDetail(start, end, span) {
        return Service.post("/home/merchant/agent/today/pay", {start, end, span});
    },
    getMerchantAgentProfit(start, end, span) {
        return Service.post("/home/merchant/agent/profit/today/pay", {start, end, span});
    },
    getBalanceErrorUser() {
        return Service.post("/home/company/vip/balance/error/number");
    },
    getAgentCustomerStatistics(condition) {
        return Service.post("/home/agent/customer/statistics/report", condition);
    },
    getAllMerchantPayOrderAmountByChannelTypeId(channelTypeId, start, end) {
        return Service.post("/home/parent/company/merchant/channel/amount", {channelTypeId, start, end});
    },
    getAllFreeByType(type, start, end) {
        return Service.post("/home/parent/company/free/type/amount", {type, start, end});
    },
    getAllBonusByType(type, start, end) {
        return Service.post("/home/parent/company/bonus/type/amount", {type, start, end});
    },
    getAllRemitAndExchangeByType(type, start, end) {
        return Service.post("/home/parent/company/remit/type/amount", {type, start, end});
    },
    getAllInterestByType(type, start, end) {
        return Service.post("/home/parent/company/interest/type/amount", {type, start, end});
    },
    getChildCompanyVipDetailByType(type, start, end) {
        return Service.post("/home/child/company/order/type/amount", {type, start, end});
    },
    getChildAllFreeByType(type, start, end) {
        return Service.post("/home/child/company/free/type/amount", {type, start, end});
    },
    getChildAllBonusByType(type, start, end) {
        return Service.post("/home/child/company/bonus/type/amount", {type, start, end});
    },
    getChildAllRemitAndExchangeByType(type, start, end) {
        return Service.post("/home/child/company/remit/type/amount", {type, start, end});
    },
    getChildAllInterestByType(start, end) {
        return Service.post("/home/child/company/interest/type/amount", {start, end});
    },
    getCompanyAgentVipDetailByType(type, start, end) {
        return Service.post("/home/agent/company/order/type/amount", {type, start, end});
    },
    getCompanyAgentAllFreeByType(type, start, end) {
        return Service.post("/home/agent/company/free/type/amount", {type, start, end});
    },
    getCompanyAgentAllBonusByType(type, start, end) {
        return Service.post("/home/agent/company/bonus/type/amount", {type, start, end});
    },
    getCompanyAgentAllRemitAndExchangeByType(type, start, end) {
        return Service.post("/home/agent/company/remit/type/amount", {type, start, end});
    },
    getMerchantAllPayOrderByType(type, start, end) {
        return Service.post("/home/merchant/order/type/amount", {type, start, end});
    },
    getMerchantAllFreeByType(type, start, end) {
        return Service.post("/home/merchant/free/type/amount", {type, start, end});
    },
    getMerchantAllRemitAndExchangeByType(type, start, end) {
        return Service.post("/home/merchant/remit/type/amount", {type, start, end});
    },
    getMerchantAllInterestByType(start, end) {
        return Service.post("/home/merchant/interest/type/amount", {start, end});
    },
    getMerchantAgentAllPayOrderByType(type, start, end) {
        return Service.post("/home/agent/merchant/order/type/amount", {type, start, end});
    },
    getMerchantAgentAllFreeByType(type, start, end) {
        return Service.post("/home/agent/merchant/free/type/amount", {type, start, end});
    },
    getMerchantAgentAllBonusByTypes(type, start, end) {
        return Service.post("/home/agent/merchant/bonus/type/amount", {type, start, end});
    },
    getMerchantAgentAllRemitAndExchangeByType(type, start, end) {
        return Service.post("/home/agent/merchant/remit/type/amount", {type, start, end});
    }
}